import * as windowGetters from "@walletconnect/window-getters";
export const getFromWindow = windowGetters.getFromWindow;
export const getFromWindowOrThrow = windowGetters.getFromWindowOrThrow;
export const getDocumentOrThrow = windowGetters.getDocumentOrThrow;
export const getDocument = windowGetters.getDocument;
export const getNavigatorOrThrow = windowGetters.getNavigatorOrThrow;
export const getNavigator = windowGetters.getNavigator;
export const getLocationOrThrow = windowGetters.getLocationOrThrow;
export const getLocation = windowGetters.getLocation;
export const getCryptoOrThrow = windowGetters.getCryptoOrThrow;
export const getCrypto = windowGetters.getCrypto;
export const getLocalStorageOrThrow = windowGetters.getLocalStorageOrThrow;
export const getLocalStorage = windowGetters.getLocalStorage;
//# sourceMappingURL=window.js.map